<template>
  <div class="notification" @click.stop="$emit('click')">
    {{ textMessage }}
  </div>
</template>

<script>
export default {
  name: 'base-notification',
  props: {
    textMessage: {
      type: String,
      required: true
    }
  }
};
</script>
